var _title, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": "twitterTitle twitterDesc",
    viewBox: "0 0 64 52.01"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Compartilhar no twitter")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M64 6.16a26.247 26.247 0 01-7.54 2.07A13.16 13.16 0 0062.23.97a26.19 26.19 0 01-8.33 3.19C51.5 1.59 48.09 0 44.31 0c-7.25 0-13.13 5.88-13.13 13.13 0 1.03.12 2.03.34 2.99-10.91-.54-20.58-5.77-27.06-13.72C3.33 4.34 2.68 6.6 2.68 9c0 4.55 2.32 8.57 5.84 10.93-2.15-.06-4.17-.66-5.94-1.64v.17c0 6.36 4.53 11.67 10.53 12.88-1.1.3-2.26.46-3.46.46-.85 0-1.68-.08-2.47-.24 1.67 5.22 6.52 9.01 12.27 9.12A26.337 26.337 0 013.14 46.3c-1.06 0-2.1-.07-3.13-.18 5.81 3.72 12.71 5.9 20.13 5.9 24.15 0 37.35-20.01 37.35-37.36 0-.56-.01-1.13-.03-1.7 2.55-1.86 4.77-4.17 6.54-6.8z"
  })));
}

export default SvgTwitter;